export default __webpack_public_path__ + "static/media/SN4-2.d67a96f0.jpg";